__turbopack_context__.v({
  "container": "OutletCardSkeleton-module-scss-module__URenHW__container",
  "footerMeta": "OutletCardSkeleton-module-scss-module__URenHW__footerMeta",
  "footerRow": "OutletCardSkeleton-module-scss-module__URenHW__footerRow",
  "infoContainer": "OutletCardSkeleton-module-scss-module__URenHW__infoContainer",
  "leftFooterContainer": "OutletCardSkeleton-module-scss-module__URenHW__leftFooterContainer",
  "logoPlaceholder": "OutletCardSkeleton-module-scss-module__URenHW__logoPlaceholder",
  "outletAddress": "OutletCardSkeleton-module-scss-module__URenHW__outletAddress",
  "outletName": "OutletCardSkeleton-module-scss-module__URenHW__outletName",
  "topContainer": "OutletCardSkeleton-module-scss-module__URenHW__topContainer",
});
